import React from "react";
import { Form, Row, Col, Accordion } from "react-bootstrap";
import ImagePlaceholder from "../../../assets/img/img_placeholder.png";
import X from "../../../assets/img/x.png";
import { Button } from "react-bootstrap";
import BankDetailsSection from "../Sections/BankDetailsSection";
import FileUploadField from "../../../Common/FileUploadField";
import FamilyDetailsSection from "../Sections/FamilyDetailsSection";
export default function PersonalInfoSection({
  employeeData,
  handleInputChange,
  states,
  cities,
  pincodes,
  permanentCities,
  permanentPincodes,
  handleStateChange,
  handleCityChange,
  handlePermanentStateChange,
  handlePermanentCityChange,
  errors,
  deleteFile,
  photoLoad,

  familyDetail,
  AddFamilyMember,
  deleteFamily,
  chequePhoto,
}) {
  const preventLeadingSpace = (e) => {
    if (e.key === " " && e.currentTarget.value.length === 0) {
      e.preventDefault();
    }
  };

  return (
    <div
      className="bg-white p-4 shadow pb-5 rounded-3"
      style={{
        marginLeft: "0.8rem",
        marginRight: "0.8rem",
        marginBottom: "4rem",
      }}
    >
      <div className="d-flex justify-content-between border-bottom pb-3">
        <h4
          className="text-capitalize icueTextPrimary"
          style={{ color: "#2f4766" }}
        >
          Personal Information
        </h4>
      </div>
      <div className="row pt-4">
        {/* Photo and Resume Upload */}
        <div className="row mb-4">
          <div className="form col-3 d-flex flex-column">
            <label htmlFor="uploadPhoto" style={{ color: "#334d6e" }}>
              Upload Your Photo*
            </label>
            <FileUploadField
              name="profile_pic"
              value={employeeData.profile_pic}
              onChange={(e) => handleInputChange(e, "employee")}
              onDelete={() => deleteFile("profile_pic")}
              error={errors.profile_pic}
              isLoading={photoLoad}
              placeholder={ImagePlaceholder}
              deleteIcon={X}
            />
          </div>
          <div className="form col-3 d-flex flex-column px-5">
            <label htmlFor="uploadResume" style={{ color: "#334d6e" }}>
              Upload Resume*
            </label>
            <FileUploadField
              name="resume"
              value={employeeData.resume}
              onChange={(e) => handleInputChange(e, "employee")}
              onDelete={() => deleteFile("resume")}
              error={errors.resume}
              isLoading={photoLoad}
              placeholder={ImagePlaceholder}
              deleteIcon={X}
            />
          </div>
        </div>

        {/* Basic Personal Details (outside accordion for immediate visibility) */}
        <Row className="mb-4">
          <Col md={4}>
            <Form.Group className="mb-3" controlId="title">
              <Form.Label style={{ color: "#334d6e" }}>Title</Form.Label>
              <Form.Select
                name="title"
                value={employeeData.title}
                onChange={(e) => handleInputChange(e, "employee")}
                isInvalid={!!errors.title}
                className="  text-muted"
              >
                {/* <option value="">Select Title</option>
                <option value="mr">Mr.</option>
                <option value="ms">Ms.</option>
                <option value="mrs">Mrs.</option> */}
                <option value="mr.">mr.</option>
                <option value="ms.">ms.</option>
                <option value="mrs.">mrs.</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.title}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="first_name">
              <Form.Label style={{ color: "#334d6e" }}>First Name</Form.Label>
              <Form.Control
                type="text"
                name="first_name"
                className="  text-muted"
                value={employeeData.first_name}
                onChange={(e) => handleInputChange(e, "employee")}
                onKeyDown={preventLeadingSpace}
                isInvalid={!!errors.first_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.first_name}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="last_name">
              <Form.Label style={{ color: "#334d6e" }}>Last Name</Form.Label>
              <Form.Control
                className="  text-muted"
                type="text"
                name="last_name"
                value={employeeData.last_name}
                onChange={(e) => handleInputChange(e, "employee")}
                onKeyDown={preventLeadingSpace}
                isInvalid={!!errors.last_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.last_name}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label
                style={{ color: "#334d6e" }}
                htmlFor="icuePersonalFormCueMemEmail"
              >
                Email
              </Form.Label>
              <Form.Control
                className="  text-muted"
                type="email"
                name="email"
                id="icuePersonalFormCueMemEmail"
                value={employeeData.email}
                onChange={(e) => handleInputChange(e, "employee")}
                onKeyDown={preventLeadingSpace}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="dob">
              <Form.Label style={{ color: "#334d6e" }}>
                {" "}
                Date Of Birth
              </Form.Label>
              <Form.Control
                className="  text-muted"
                type="date"
                name="dob"
                value={
                  employeeData.dob
                    ? new Date(employeeData.dob).toISOString().slice(0, 10)
                    : ""
                }
                onChange={(e) => handleInputChange(e, "employee")}
                onKeyDown={preventLeadingSpace}
                isInvalid={!!errors.dob}
              />
              <Form.Control.Feedback type="invalid">
                {errors.dob}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="gender">
              <Form.Label style={{ color: "#334d6e" }}>Gender</Form.Label>
              <Form.Select
                name="gender"
                className="  text-muted"
                value={employeeData.gender}
                onChange={(e) => handleInputChange(e, "employee")}
                isInvalid={!!errors.gender}
              >
                {/* <option value="">Select gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option> */}
                <option value="selft employed">Male</option>
                <option value="self">Female</option>
                <option value="employed">Other</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.gender}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="marital_status">
              <Form.Label style={{ color: "#334d6e" }}>
                Marital Status
              </Form.Label>
              <Form.Select
                name="marital_status"
                className="  text-muted"
                value={employeeData.marital_status}
                onChange={(e) => handleInputChange(e, "employee")}
                isInvalid={!!errors.marital_status}
              >
                {/* <option value="">Select Marital Status</option>
                <option value="YES">yes</option>
                <option value="NO">No</option> */}
                <option value="selft employed">Yes</option>
                <option value="self">No</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.marital_status}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="blood_group">
              <Form.Label style={{ color: "#334d6e" }}>Blood Group</Form.Label>
              <Form.Control
                className="  text-muted"
                type="text"
                name="blood_group"
                value={employeeData.blood_group}
                onChange={(e) => handleInputChange(e, "employee")}
                onKeyDown={preventLeadingSpace}
                isInvalid={!!errors.blood_group}
              />
              <Form.Control.Feedback type="invalid">
                {errors.blood_group}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        {/* Accordion for Contact Details, Residential/Permanent Address, Family Details, Bank Details */}
        <Accordion defaultActiveKey="0" alwaysOpen>
          {" "}
          {/* `alwaysOpen` keeps all items expanded, remove if you want only one open */}
          {/* Contact Details */}
          <Accordion.Item eventKey="0">
            <Accordion.Header style={{ color: "#334d6e" }}>
              Contact Details
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label
                      style={{ color: "#334d6e" }}
                      htmlFor="icuePersonalFormCueMemPhoneNo"
                    >
                      Contact Number
                    </Form.Label>
                    <Form.Control
                      className="  text-muted"
                      type="text"
                      maxLength="10"
                      id="icuePersonalFormCueMemPhoneNo"
                      name="contact_number"
                      value={employeeData.contact_number}
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        handleInputChange(
                          {
                            target: {
                              name: "contact_number",
                              value: numericValue,
                            },
                          },
                          "employee"
                        );
                      }}
                      onKeyDown={preventLeadingSpace}
                      isInvalid={!!errors.contact_number}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.contact_number}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label
                      style={{ color: "#334d6e" }}
                      htmlFor="icuePersonalFormCueMemMobNo"
                    >
                      Emergency Contact Number
                    </Form.Label>
                    <Form.Control
                      className="  text-muted"
                      type="text"
                      name="emergency_contact_number"
                      maxLength="10"
                      value={employeeData.emergency_contact_number}
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(
                          /[^0-9]/g,
                          ""
                        );
                        handleInputChange(
                          {
                            target: {
                              name: "emergency_contact_number",
                              value: numericValue,
                            },
                          },
                          "employee"
                        );
                      }}
                      onKeyDown={preventLeadingSpace}
                      isInvalid={!!errors.emergency_contact_number}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.emergency_contact_number}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              {/* Residential Address */}
              <h5 className="mt-4">Residential Address</h5>
              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="state">
                    <Form.Label style={{ color: "#334d6e" }}>State</Form.Label>
                    <Form.Select
                      name="state"
                      className="  text-muted"
                      value={employeeData.state}
                      onChange={handleStateChange}
                      isInvalid={!!errors.state}
                    >
                      <option value="">Select State</option>
                      {states.map((s) => (
                        <option key={s.id} value={s.state}>
                          {s.state}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.state}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="city">
                    <Form.Label style={{ color: "#334d6e" }}>City</Form.Label>
                    <Form.Select
                      name="city"
                      className="  text-muted"
                      value={employeeData.city}
                      onChange={handleCityChange}
                      isInvalid={!!errors.city}
                    >
                      <option value="">Select City</option>
                      {cities.map((c) => (
                        <option key={c.id} value={c.city}>
                          {c.city}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.city}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="pincode">
                    <Form.Label style={{ color: "#334d6e" }}>
                      Pincode
                    </Form.Label>
                    <Form.Select
                      name="pincode"
                      className="  text-muted"
                      value={employeeData.pincode}
                      onChange={(e) => handleInputChange(e, "employee")}
                      isInvalid={!!errors.pincode}
                    >
                      <option value="">Select Pincode</option>
                      {pincodes.map((p) => (
                        <option key={p.id} value={p.pincode}>
                          {p.pincode}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.pincode}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="residential_address">
                    <Form.Label style={{ color: "#334d6e" }}>
                      Address Line
                    </Form.Label>
                    <Form.Control
                      className="  text-muted"
                      type="text"
                      name="residential_address"
                      value={employeeData.residential_address}
                      onChange={(e) => handleInputChange(e, "employee")}
                      isInvalid={!!errors.residential_address}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.residential_address}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="landmark">
                    <Form.Label style={{ color: "#334d6e" }}>
                      Landmark
                    </Form.Label>
                    <Form.Control
                      className="  text-muted"
                      type="text"
                      name="landmark"
                      value={employeeData.landmark}
                      onChange={(e) => handleInputChange(e, "employee")}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="country">
                    <Form.Label style={{ color: "#334d6e" }}>
                      Country
                    </Form.Label>
                    <Form.Control
                      className="  text-muted"
                      type="text"
                      name="country"
                      value={employeeData.country}
                      onChange={(e) => handleInputChange(e, "employee")}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Permanent Address */}
              <h5 className="mt-4">Permanent Address</h5>
              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="pa_state">
                    <Form.Label style={{ color: "#334d6e" }}>State</Form.Label>
                    <Form.Select
                      name="pa_state"
                      className="  text-muted"
                      value={employeeData.pa_state}
                      onChange={handlePermanentStateChange}
                      isInvalid={!!errors.pa_state}
                    >
                      <option value="">Select State</option>
                      {states.map((s) => (
                        <option key={s.id} value={s.state}>
                          {s.state}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.pa_state}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="pa_city">
                    <Form.Label style={{ color: "#334d6e" }}>City</Form.Label>
                    <Form.Select
                      name="pa_city"
                      className="  text-muted"
                      value={employeeData.pa_city}
                      onChange={handlePermanentCityChange}
                      isInvalid={!!errors.pa_city}
                    >
                      <option value="">Select City</option>
                      {permanentCities.map((c) => (
                        <option key={c.id} value={c.city}>
                          {c.city}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.pa_city}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="pa_pincode">
                    <Form.Label style={{ color: "#334d6e" }}>
                      Pincode
                    </Form.Label>
                    <Form.Select
                      name="pa_pincode"
                      className="  text-muted"
                      value={employeeData.pa_pincode}
                      onChange={(e) => handleInputChange(e, "employee")}
                      isInvalid={!!errors.pa_pincode}
                    >
                      <option value="">Select Pincode</option>
                      {permanentPincodes.map((p) => (
                        <option key={p.id} value={p.pincode}>
                          {p.pincode}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.pa_pincode}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="permanent_address">
                    <Form.Label style={{ color: "#334d6e" }}>
                      Address Line
                    </Form.Label>
                    <Form.Control
                      className="  text-muted"
                      type="text"
                      name="permanent_address"
                      value={employeeData.permanent_address}
                      onChange={(e) => handleInputChange(e, "employee")}
                      isInvalid={!!errors.permanent_address}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.permanent_address}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="pa_landmark">
                    <Form.Label style={{ color: "#334d6e" }}>
                      Landmark
                    </Form.Label>
                    <Form.Control
                      className="  text-muted"
                      type="text"
                      name="pa_landmark"
                      value={employeeData.pa_landmark}
                      onChange={(e) => handleInputChange(e, "employee")}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3" controlId="pa_country">
                    <Form.Label style={{ color: "#334d6e" }}>
                      Country
                    </Form.Label>
                    <Form.Control
                      className="  text-muted"
                      type="text"
                      name="pa_country"
                      value={employeeData.pa_country}
                      onChange={(e) => handleInputChange(e, "employee")}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
          {/* Family Details */}
          <Accordion.Item eventKey="1">
            <Accordion.Header style={{ color: "#334d6e" }}>
              Family Details
            </Accordion.Header>
            <Accordion.Body>
              {" "}
              <FamilyDetailsSection
                familyDetail={familyDetail}
                handleInputChange={handleInputChange}
                deleteFamily={deleteFamily}
                AddFamilyMember={AddFamilyMember}
                errors={errors}
                preventLeadingSpace={preventLeadingSpace}
              />
            </Accordion.Body>
            {/* <Accordion.Body>
              {familyDetail.map((member, index) => (
                <div
                  key={index}
                  className="border p-3 mb-3 rounded position-relative"
                >
                  {familyDetail.length > 1 && (
                    <span
                      onClick={() => deleteFamily(index)}
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                        color: "red",
                        fontSize: "1.2rem",
                      }}
                      title="Remove Family Member"
                    >
                      <i className="fas fa-trash"></i>{" "}
                      
                    </span>
                  )}
                  <Row>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label style={{ color: "#334d6e" }}>Member Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="member_name"
                          value={member.member_name}
                          onChange={(e) =>
                            handleInputChange(e, "Family", index)
                          }
                          onKeyDown={preventLeadingSpace}
                          isInvalid={
                            !!errors[`familyDetail_member_name_${index}`]
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors[`familyDetail_member_name_${index}`]}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label style={{ color: "#334d6e" }}>Relation</Form.Label>
                        <Form.Control
                          type="text"
                          name="relation"
                          value={member.relation}
                          onChange={(e) =>
                            handleInputChange(e, "Family", index)
                          }
                          onKeyDown={preventLeadingSpace}
                          isInvalid={!!errors[`familyDetail_relation_${index}`]}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors[`familyDetail_relation_${index}`]}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label style={{ color: "#334d6e" }}>Date Of Birth</Form.Label>
                        <Form.Control
                          type="date"
                          name="member_dob"
                          value={
                            member.member_dob
                              ? new Date(member.member_dob)
                                  .toISOString()
                                  .slice(0, 10)
                              : ""
                          }
                          onChange={(e) =>
                            handleInputChange(e, "Family", index)
                          }
                          isInvalid={
                            !!errors[`familyDetail_member_dob_${index}`]
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors[`familyDetail_member_dob_${index}`]}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label style={{ color: "#334d6e" }}>Occupation</Form.Label>
                        <Form.Control
                          type="text"
                          name="occupation"
                          value={member.occupation}
                          onChange={(e) =>
                            handleInputChange(e, "Family", index)
                          }
                          onKeyDown={preventLeadingSpace}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label style={{ color: "#334d6e" }}>Contact Number</Form.Label>
                        <Form.Control
                          type="text"
                          maxLength="10"
                          name="member_contact_number"
                          value={member.member_contact_number}
                          onChange={(e) => {
                            const numericValue = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            );
                            handleInputChange(
                              {
                                target: {
                                  name: "member_contact_number",
                                  value: numericValue,
                                },
                              },
                              "Family",
                              index
                            );
                          }}
                          onKeyDown={preventLeadingSpace}
                          isInvalid={
                            !!errors[
                              `familyDetail_member_contact_number_${index}`
                            ]
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {
                            errors[
                              `familyDetail_member_contact_number_${index}`
                            ]
                          }
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              ))}
              <Button
                variant="primary"
                onClick={AddFamilyMember}
                className="mt-3"
              >
                Add Family Member
              </Button>
            </Accordion.Body> */}
          </Accordion.Item>
          {/* Bank Details */}
          <Accordion.Item eventKey="2">
            <Accordion.Header>Bank Details</Accordion.Header>
            <Accordion.Body>
              <BankDetailsSection
                employeeData={employeeData}
                handleInputChange={handleInputChange}
                errors={errors}
                deleteFile={deleteFile}
                photoLoad={photoLoad}
                chequePhoto={chequePhoto}
                preventLeadingSpace={preventLeadingSpace}
              />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
}
